import React from 'react';
import {  getSelectedOption } from './commonRingUtils';
import { getV1FinishItems } from './finishItems';
import { getOutsideFeatureItems } from './outsideFeatureItems';
import { getSecondaryOutsideFeatureItems } from './secondaryOutsideFeatureItems';
import { getShapeItems } from './shapeItems';
import { getEngravingItems } from './engravingItems';
import { getCategorizedOptions } from './basic';
import { ITab, ITabs } from '../app/types/customizer';
import SwatchFilter from '../app/components/SwatchFilter';
import BoxFilter from '../app/components/BoxFilter';
import SizeFilter from '../app/components/SizeFilter/SizeFilter';
import Summary from '../app/components/Summary';
import SummaryInfo from '../app/components/SummaryInfo/SummaryInfo';
import { IPageData } from '../app/pages/RingCustomizer/Pages';
import PinHelpContent from "../app/components/Pin";

export const getV1PageData = (props: IPageData) => {
    const { product: productData, subpath, storeData, isBuildFromScratch } = props;
    const product = { ...productData };
    product.categories = getCategorizedOptions('band', storeData);
    const items: ITabs = [
        {
            title: 'Category',
            eventKey: 'category',
            component: BoxFilter,
            isEnabled: true && !['legacy-touch', 'legacy-touch-dev'].includes(subpath),
            isSelected: isBuildFromScratch,
            content: {
                hasSwatch: true,
                fieldType: 'category',
                options: product.categories,
                selectedOption: getSelectedOption(product.categories),
            },
        },
        {
            title: 'Material',
            label: 'Ring Material',
            eventKey: 'material',
            component: SwatchFilter,
            isEnabled: product.ring_material?.length > 0,
            isSelected: !isBuildFromScratch,
            content: {
                // showDefaultTitle: false,
                // displayShowMoreOption: false,
                // meta: getFilterMetaData(product, 'ring_material'),
                // warning: getWarning(product, 'ring_material'),
                hasSwatch: true,
                fieldType: 'ring_materials',
                options: product.ring_material,
                selectedOption: getSelectedOption(product.ring_material),
            },
        },
        {
            title: 'Shape',
            eventKey: 'shape',
            items: getShapeItems(product),
            tabStyle: 'box',
        },
        {
            title: 'Finish',
            eventKey: 'finish',
            items: getV1FinishItems(product),
            tabStyle: 'box',
        },
        {
            title: 'Outside Feature',
            eventKey: 'outsideFeature_1',
            ...getOutsideFeatureItems(product),
            tabStyle: 'box',
        },
        {
            title: () => <>2<sup>nd</sup> Outside Feature</>,
            eventKey: 'outsideFeature_2',
            ...getSecondaryOutsideFeatureItems(product),
            tabStyle: 'box',
        },
        {
            title: 'Inside Feature',
            label: 'Inside Sleeve',
            eventKey: 'insideFeature',
            component: SwatchFilter,
            isEnabled: product.sleeve?.length > 0,
            content: {
                // showDefaultTitle: false,
                // displayShowMoreOption: false,
                // meta: getFilterMetaData(product, 'sleeve'),
                // warning: getWarning(product, 'sleeve'),
                hasSwatch: true,
                fieldType: 'sleeve',
                options: product.sleeve,
                selectedOption: getSelectedOption(product.sleeve),
            },
        },
        {
            title: 'Engraving',
            eventKey: 'engraving',
            // disclaimer: "\"The customer's engraving as they have typed it, or nothing if not added\""
            tabStyle: 'box',
            ...getEngravingItems(product, product.engraving_new)
        },
        {
            title: 'Size',
            label: 'Ring Size',
            eventKey: 'ringSize',
            component: SizeFilter,
            isEnabled: product.size?.length > 0 && !['revolution', 'stonebrook-jewelry', 'foundry'].includes(subpath),
            content: {
                // showDefaultTitle: true,
                // displayShowMoreOption: false,
                // meta: getFilterMetaData(product, 'size'),
                // warning: getWarning(product, 'size'),
                hasSwatch: false,
                fieldType: 'size',
                options: product.size || [],
                selectedOption: getSelectedOption(product.size),
            },
        },
        {
            title: product.msrp ? ''  : 'Pin',
            eventKey: 'pin',
            component: PinHelpContent,
            isEnabled: ['legacy-touch', 'legacy-touch-dev'].includes(subpath),
        },
        {
            title: product.msrp ? ''  : 'Summary',
            eventKey: 'summary',
            component: Summary,
            isEnabled: subpath !== 'customiaaze',
        },
        {
            title: 'Info',
            eventKey: 'summaryInfo',
            component: SummaryInfo,
            isEnabled: subpath === 'customize',
        },
    ];
    const filtered = items.filter((tab: ITab) => tab.isEnabled || tab.items?.length);
    return filtered;
};